export enum MatchProfileRuleSet {
  Fiba = "FIBA",
  Other = "OTHER",
}
